import type { FC } from 'react'
import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { useFormContext } from 'react-hook-form'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { ExitIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ExitIcon'
import { FilterIcon } from '@frontend/pole-ui/lib/components/Icon/svg/FilterIcon'
import classNames from 'classnames'
import { DEFAULT_FORM_VALUES } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsFilter/constants'
import { PRODUCTS_BLOCK_ID } from '@/pages/Financing/components/FinancingProducts/constants'
import { scrollTo } from '@/utils/helpers'
import { ProductsListContext } from '../../constants'
import './styles.scss'

export const FinancingMobileBanner: FC = () => {
  const { productsList, otherProductsList, isFilterChanged } = useContext(ProductsListContext)
  const { reset } = useFormContext()

  const onButtonClick = () => {
    scrollTo(`#${PRODUCTS_BLOCK_ID}`, false)
  }

  const onFilterReset = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    reset(DEFAULT_FORM_VALUES)
  }

  if (!process.browser) {
    return null
  }

  const headerNode = document?.querySelector('#headerPortal')

  const className = classNames(['financingMobileBanner'], {
    'financingMobileBanner--intersected': productsList?.isBlockIntersected === 'true' || otherProductsList?.isBlockIntersected === 'true',
  })

  if (!headerNode) {
    return null
  }

  const content = (
    <div className={className}>
      <div className="page-wrapper">
        <button
          className={classNames('financingMobileBanner__button', { 'financingMobileBanner__button--active': isFilterChanged })}
          onClick={onButtonClick}
        >
          <Icon component={<FilterIcon />} size={EIconSize.XS} />
          <span>Фильтры</span>
          {isFilterChanged && (
            <div className="financingMobileBanner__reset" onClick={onFilterReset}>
              <Icon component={<ExitIcon />} size={EIconSize.XS} />
            </div>
          )}
        </button>
      </div>
    </div>
  )

  return createPortal(content, headerNode)
}
